import React from "react";
import clsx from "clsx";
import * as Icon from "react-feather";

import "./build-stage-tracker.css";

const STATE_NAMES = { done: "Done", current: "Current step", upcoming: "Not started" };

class BuildStageTracker extends React.PureComponent {
	render() {
		const { stages } = this.props;
		return (
			<ol className="build-stage-tracker" aria-label="Build stages">
				{stages.map((stage, index) => {
					const isDone = stage.state === "done";
					const isCurrent = stage.state === "current";
					const isLast = index === stages.length - 1;
					const stageNumber = index + 1;
					const isDetailShown = (isDone || isCurrent) && !!stage.detail;
					const secondLine = isDetailShown ? stage.detail : stage.purpose;
					return (
						<li
							key={stage.key}
							className={clsx("build-stage-tracker__stage", `build-stage-tracker__stage--${stage.state}`)}
							aria-current={isCurrent ? "step" : undefined}
						>
							<span className="build-stage-tracker__marker" role="img" aria-label={STATE_NAMES[stage.state]}>
								{isDone ? <Icon.Check size={12} strokeWidth={3} aria-hidden="true" /> : stageNumber}
							</span>
							<span className="build-stage-tracker__text">
								<span className="build-stage-tracker__label">{stage.label}</span>
								{secondLine && (
									<span className="build-stage-tracker__detail" title={secondLine}>
										{secondLine}
									</span>
								)}
							</span>
							{!isLast && <span className="build-stage-tracker__line" aria-hidden="true" />}
						</li>
					);
				})}
			</ol>
		);
	}
}

export default BuildStageTracker;
